import { CmObjectType } from '@svta/cml-cta'

/**
 * Common Media Server Data Object Type
 *
 *
 * @enum
 *
 * @public
 */
export const CmsdObjectType = CmObjectType as typeof CmObjectType

/**
 * @public
 */
export type CmsdObjectType = CmObjectType;
